import auth from './auth.json';

export default { ...auth };
